export const errorMessageHandler = (errorMessage, whatShouldMatch) => {
    const errors = [
        {
            code: "400",
            message: "Action takes too long"
        },
        {
            code: 400,
            message: "Incorrect timeframe for project. timeframe_start cannot be after timeframe_end. ",
            userFriendlyMessage: "The end date must come after the start date."
        },
        {
            code: "404",
            message: "Resource was not found"
        },
        {
            code: "500",
            message: "Server error"
        }
    ];
    if (whatShouldMatch) {
        const foundErrArr = errors.filter(err => {
            return errorMessage === err.message && whatShouldMatch === err.code
        });
        return foundErrArr[0].userFriendlyMessage
    } else {
        const foundErrArr = errors.filter(err => errorMessage.match(err.code));
        return foundErrArr[0].message
    }

};
